import {useStateContext} from "../../context/ContextProvider";
import {Link, Navigate, Outlet} from "react-router-dom";
import BaseApi from "../../services/Api";
import {useEffect, useState} from "react";
import { useRef } from "react";
import {Dropdown, Collapse} from "react-bootstrap";
import AvatarToggle from "../../components/AvatarToggle";
import style from "./style.module.css"

import logoVipa from "../../images/logo_vipa.png"

const DefaultLayout = () => {
  const [asideVisible, setAsideVisible] = useState(false);
  const {user, token, setUser, setToken} = useStateContext();
  const [isMobile, setIsMobile] = useState(false);

  const hambContentRef = useRef("");
  const contentRef = useRef("");
  const handleHambContent = () => {
    if (window.innerWidth <= 991) {
      hambContentRef.current.classList.toggle(style.active)
      contentRef.current.classList.toggle(style.unnactive)
    }
  }

  const handleResize = () => {
    if (window.innerWidth <= 991) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }

  window.addEventListener("resize", handleResize)

  useEffect(() => {
    handleResize()

    BaseApi.get('/user')
      .then(({data}) => {
        setUser(data);
      }).catch(()=>{
        if (!token) {
          
            window.location.href = '/admin/login';
          
        }
      })
  }, [])

  if (!token) {
    return <Navigate to="/admin/login"/>
  }

  const onLogout = (ev) => {
    ev.preventDefault();
    BaseApi.post('/logout')
      .then(() => {
        setUser({});
        setToken(null);
      })
  }

  return (
    <div>
      <nav className={`navbar ${style.navbar}`}>
        <div className={style.hamburger}>
            <i className="bi bi-list h1" 
              onClick={handleHambContent} 
            />
        </div>
        <div className={style.paws}/>
        <div className="container-lg" style={{minHeight: "40px"}}>
          <div className="d-flex">
            <div className="d-flex justify-content-center align-items-center me-2">
              <button className="d-lg-none" type="button" onClick={() => setAsideVisible(!asideVisible)}>
                {asideVisible ? <i className="bi bi-x"/> : <i className="bi bi-list"/>}
              </button>
            </div>

            <Link to="/admin/dashboard" className={style.logo} style={{fontWeight: "bold"}}>
              <img src={logoVipa} alt="logo" width="55" height="55"/>
            </Link>
          </div>
          <div className={style.avatar}>
            <div>
              <Dropdown>
                <Dropdown.Toggle as={AvatarToggle} id="dropdown-custom-toggle">
                  <img src={user.image} alt=""/>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.ItemText>
                    <div className="d-flex flex-column">
                      <span>
                      {user.name}
                    </span>
                      <span>
                      {user.email}
                    </span>
                    </div>
                  </Dropdown.ItemText>
                  <Dropdown.Divider />
                  <Dropdown.Item href="#" onClick={onLogout}>
                    Sair
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </nav>
      <div id="defaultLayout" className={style.content_container}>
        <div className={style.link_container} ref={hambContentRef}>
          <div className={style.links}>
            <Link className={style.links_text} to="/admin/dashboard" onClick={handleHambContent}>Painel de Controles</Link>
            <Link className={style.links_text} to="/admin/animais" onClick={handleHambContent}>Animais</Link>
            <Link className={style.links_text} to="/admin/banner" onClick={handleHambContent}>Banner</Link>
            <Link className={style.links_text} to="/admin/doacoes" onClick={handleHambContent}>Doações</Link>
            <Link className={style.links_text} to="/admin/historia" onClick={handleHambContent}>História</Link>
            <Link className={style.links_text} to="/admin/informacoes" onClick={handleHambContent}>Informações</Link>
            <Link className={style.links_text} to="/admin/parceiros" onClick={handleHambContent}>Parceiros</Link>
            <Link className={style.links_text} to="/admin/pretendente" onClick={handleHambContent}>Pretendente</Link>
            <Link className={style.links_text} to="/admin/usuarios" onClick={handleHambContent}>Usuários</Link>
            {isMobile && (
              <>
                <h1>{user.name}</h1>
                <h1>{`(${user.email})`}</h1>
                <button onClick={onLogout}>Sair</button>
              </>
            )}
          </div>
        </div>
        <div className="container-fluid mt-2 overflow overflow-x-auto" ref={contentRef}>
          <header>
            <div>
              <h1>Painel de Controle</h1>
            </div>
          </header>
          <main>
            <Outlet/>
          </main>
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout;